// extracted by mini-css-extract-plugin
module.exports = {"base":"8px","machines":"allMachinesMenu_machines__wvP91","moreColumns":"allMachinesMenu_moreColumns__5igL_"};